export const ATTENTIVE_URLS = {
  PRIVACY: "https://attnl.tv/p/gb1",
  TERMS: "https://attnl.tv/t/gb1",
};
